import { Injectable } from '@angular/core';
import { BaseService } from './base.service';

@Injectable()
export class TempMailService {

  constructor(private base: BaseService) { }

  save(data){
    return this.base.post('/api/email-temp', data);
  }

  newMassEmail(data){
    return this.base.post('/api/mass-email/send-V1', data);
  }

  onCreateTemplate(data){
    return this.base.post('/api/email/create-template', data);
  }

  onTemplateMaster(data){
    return this.base.post('/api/email-templates/dropdown', data);
  }

  onTemplateListing(data){
    return this.base.post('/api/email-templates', data);
  }

  onStatusUpdate(data){
    return this.base.post('/api/email/template/status-update', data);
  }

  onEditEmailTemplate(data){
    return this.base.post('/api/email-templates/show', data);
  }

  onUpdateEmailTemplate(data){
    return this.base.post('/api/email-template/update', data);
  }

   onEditEmail(data){
    return this.base.post('/api/mass-email/edit-mailer', data);
  }

  onTestEmail(data){
    return this.base.post('/api/mass-email/test-mailer', data);
  }

  onUpdateEmail(data){
    return this.base.post('/api/mass-email/update-mailer', data);
  }

  onDeleteMail(data){
    return this.base.post('/api/mass-email/delete-mailer', data);
  }

  exportEmail(data){
        return this.base.post('/api/mass-email/list-mailer', data);
  }

  onRefreshEmail(data){
        return this.base.post('/api/mass-email/refresh-mailer', data);
  }

 
}
